// extracted by mini-css-extract-plugin
export default {"assignBtn":"isni-assign_assignBtn__mIvXk"};